import { render } from "./AlternativeTransitModes.vue?vue&type=template&id=308cae03&scoped=true"
import script from "./AlternativeTransitModes.vue?vue&type=script&lang=js"
export * from "./AlternativeTransitModes.vue?vue&type=script&lang=js"

import "./AlternativeTransitModes.vue?vue&type=style&index=0&id=308cae03&scoped=true&lang=scss"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308cae03"]])

export default __exports__